import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { AppLayout } from '@/components/routing';

import { PublicRoutes } from './public.routes';
import { AuthRoutes } from './auth.routes';
import { LearnerRoutes } from './learner.routes';
import { EnterpriseRoutes } from './enterprise.routes';
import { AdminRoutes } from './admin.routes';
import { LegalRoutes } from './legal.routes';
import { PaymentRoutes } from './payment.routes';
import { RedirectRoutes } from './redirects.routes';

const NotFound = lazy(() => import('@/pages/NotFound'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    Chargement...
  </div>
);

export function AppRoutes() {
  return (
    <AppLayout>
      <Routes>
        {/* Public pages */}
        {PublicRoutes()}
        
        {/* Authentication */}
        {AuthRoutes()}
        
        {/* Learner space */}
        {LearnerRoutes()}
        
        {/* Enterprise space */}
        {EnterpriseRoutes()}
        
        {/* Admin */}
        {AdminRoutes()}
        
        {/* Legal pages */}
        {LegalRoutes()}
        
        {/* Payment & Registration */}
        {PaymentRoutes()}
        
        {/* Legacy redirects */}
        {RedirectRoutes()}
        
        {/* 404 */}
        <Route 
          path="*" 
          element={
            <Suspense fallback={<PageLoader />}>
              <NotFound />
            </Suspense>
          } 
        />
      </Routes>
    </AppLayout>
  );
}
